// definition file for the span-util.js browser file
const policyCheckerFactory = require('./src/domain/authorizers/policy-checker');

const simpleChompLogger = {
  error: () => {},
  warn: () => {},
  info: () => {},
  debug: () => {},
  trace: () => {},
}
const policyChecker = policyCheckerFactory.init(simpleChompLogger);

var SpanClient = SpanClient || window.SpanClient || {};

SpanClient.PolicyChecker = SpanClient.PolicyChecker || policyChecker;

window.SpanClient = SpanClient;

module.exports = {};
